import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { SortOption } from '@fcom/destination-search/interfaces';

/**
 * @todo: To be moved to ui-components
 */

@Component({
  selector: 'fin-sort-options',
  styleUrls: ['./sort-options.component.scss'],
  templateUrl: './sort-options.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SortOptionsComponent {
  @Output()
  optionChange: EventEmitter<any> = new EventEmitter();

  @Input()
  fieldName: string;

  @Input()
  selected$: Observable<string>;

  @Input()
  sortOptions: SortOption[];
}
